export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14098.36a44fc7.jpg";